import { j as s } from "../accordion/Accordion-CrPiD_81.mjs";
import { forwardRef as x, useState as e, useEffect as g } from "react";
import { S as u } from "../typography/Typography-qfbU_T11.mjs";
const m = ({ progressRatio: r }) => (1 - r) * 100 * Math.PI, j = x(
  ({ progressRatio: r, label: t, size: a = "small", className: l = "", children: c, ...d }, o) => {
    const [i, n] = e(0), [p] = e(a === "small" ? "160px" : "260px");
    return g(() => {
      n(m({ progressRatio: r }));
    }, [r]), /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsxs("label", { className: "sr-only", "data-testid": "rds-progress__label", children: [
        t,
        /* @__PURE__ */ s.jsx("progress", { "data-testid": "rds-progress__progress", value: r, max: 1 })
      ] }),
      /* @__PURE__ */ s.jsxs(
        "div",
        {
          ref: o,
          "data-testid": "rds-progress",
          className: `rds-progress--circular ${l}`,
          style: { "--progress-circle-size": p },
          ...d,
          children: [
            /* @__PURE__ */ s.jsx("div", { className: "rds-progress--circular__outer", "data-testid": "rds-progress__content", children: c || /* @__PURE__ */ s.jsx(u, { "data-testid": "rds-progress__default-text", lookLike: "title-3", children: r === 1 ? "Du er i mål!" : `${r * 100} %` }) }),
            /* @__PURE__ */ s.jsxs(
              "svg",
              {
                style: { "--calculated-progress": i, "--progress": `${r + 1}s` },
                xmlns: "http://www.w3.org/2000/svg",
                version: "1.1",
                viewBox: "-10 0 120 100",
                children: [
                  /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsxs("linearGradient", { id: "GradientColor", children: [
                    /* @__PURE__ */ s.jsx("stop", { offset: "0%", stopColor: "var(--rds-heading-accent)" }),
                    /* @__PURE__ */ s.jsx("stop", { offset: "100%", stopColor: "var(--rds-background-card)" })
                  ] }) }),
                  /* @__PURE__ */ s.jsx("circle", { id: "path", cx: "50", cy: "50", r: "50", strokeLinecap: "round" }),
                  /* @__PURE__ */ s.jsx("circle", { id: "prog", cx: "50", cy: "50", r: "50", strokeLinecap: "round" })
                ]
              }
            )
          ]
        }
      )
    ] });
  }
);
j.displayName = "CircularProgress";
export {
  j as C
};
